import type { SearchParamsValuesType } from '../../../constants';
import type { DropdownOption } from '../../Dropdown';
import { PREDEFINED_DROPDOWN_OPTIONS_CONFIG } from '../config';

export type UsePredefinedDropdownOptions = {
  options: DropdownOption[];
};

export const usePredefinedDropdownOptions = (key: SearchParamsValuesType): UsePredefinedDropdownOptions => {
  const options = PREDEFINED_DROPDOWN_OPTIONS_CONFIG[key] ?? [];

  return {
    options,
  };
};
